import { useContext } from 'react';
import { PropertyPreviewContext } from '../../contexts/property-preview-context';
import type { PropertyPreviewContextValue } from '../../types/property-preview.type';

/**
 * Reads the view-owned preview resources without adding another scheduler.
 * @returns Resources or null while the access context is resolving or changing.
 */
export const usePropertyPreviewContext =
  (): PropertyPreviewContextValue | null => useContext(PropertyPreviewContext);
